import axios from "axios";

const actionSaveService = async ({commit}, payload) => {
  const service = await axios.post(`${process.env.VUE_APP_URL_API}/v1/services`, payload);
  commit("SET_NEW_SERVICE", service.data);
}

const actionEditService = async ({commit}, payload) => {
  const config = {
    headers:{
      farm:payload.farm_id
    }
  }
  const service = await axios.put(`${process.env.VUE_APP_URL_API}/v1/services/${payload.id}`, payload, config);
  commit("SET_NEW_SERVICE", service.data);
}

const actionSaveDraft = async ({commit}, payload) => {
  const config = {
    headers:{
      farm:payload.farm.id
    }
  }
  delete payload.farm;
  const service = await axios.put(`${process.env.VUE_APP_URL_API}/v1/services/${payload.id}`, payload, config);
  commit("SET_NEW_SERVICE", service.data);
}

const actionGetSingleService = async ({commit}, payload) => {
  const service = await axios.get(`${process.env.VUE_APP_URL_API}/v1/services/${payload}`);
  commit("SET_SINGLE_SERVICE", service.data);
  return service.data;
}

const actionSortAnimals = async ({commit}, payload) => {
  const service_sorted = await axios.get(`${process.env.VUE_APP_URL_API}/v1/services/${payload.service_id}`, {params:{animal_order_by:payload.param}});
  commit("SET_SINGLE_SERVICE", service_sorted.data);
}

const actionGetServices = async ({commit}, payload) => {
  const services = await axios.get(`${process.env.VUE_APP_URL_API}/v1/services`, {params:{...payload}});
  if(services.data) {
    commit("SET_SERVICES", services.data.services);
    commit("SET_PAGINATION", services.data.options.meta);
  }
}

const actionCloseService = async ({commit}, payload) => {
  const config = {
    headers:{
      farm:payload.id
    }
  }
  const closed = await axios.post(`${process.env.VUE_APP_URL_API}/v1/services/${payload.id}/close`, config);
  commit("SET_CLOSED_SERVICE", closed.data);
}

const actionGetLastService = async ({commit}, payload) => {
  const last_service = await axios.get(`${process.env.VUE_APP_URL_API}/v1/services/${payload}/last_service`,);
  commit("SET_LAST_SERVICE", last_service.data);
}

const actionValidateService = async (_, payload) => {
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/services/${payload}/validate`);
}

const actionDeleteService = async ({commit}, payload) => {
  await axios.delete(`${process.env.VUE_APP_URL_API}/v1/services/${payload.id}`);
  commit("DELETE_SERVICE", payload);
}

const actionGetLabs = async ({commit}) => {
  const labs = await axios.get(`${process.env.VUE_APP_URL_API}/v1/people/get_labors`);
  commit("SET_LABS", labs.data);
}

const actionSaveSingleMilkControl = async (_, payload) => {
  const config = {
    headers:{
      farm:payload.farm.id
    }
  }
  delete payload.farm;
  await axios.put(`${process.env.VUE_APP_URL_API}/v1/services/${payload.id}`, payload, config);
}

export default {
  actionSaveService,
  actionGetServices,
  actionGetSingleService,
  actionEditService,
  actionSaveDraft,
  actionCloseService,
  actionGetLastService,
  actionValidateService,
  actionDeleteService,
  actionGetLabs,
  actionSaveSingleMilkControl,
  actionSortAnimals
}